module.exports = __webpack_public_path__ + "static/notice-actions-do-d0c6037cf054bf9407b43e5abcd6202f.png";